'use strict'

const _ = require('lodash')
const {CompsMigrationHelper} = require('../helpers/CompsMigrationHelper')

function migrateGrid(pageJson, cache, isMobile, comp) {
    const gridData = pageJson.data.document_data[comp.dataQuery.slice(1)]
    const compsProps = pageJson.data.component_properties
    const gridProps = compsProps[comp.propertyQuery]

    if (_.has(gridProps, 'dataSource')) {
        const migratingDataSource = {
            type: gridProps.dataSource.type,
            revision: gridProps.dataSource.id
        }
        delete gridProps.dataSource
        const mobilePropsQuery = `mobile_${comp.propertyQuery}`
        if (_.has(compsProps, mobilePropsQuery)) {
            delete compsProps[mobilePropsQuery].dataSource
        }
        _.set(gridData, 'dataSource', migratingDataSource)
    }
}

module.exports = {
    name: 'migrateGridDataSource',
    version: 1,
    exec(pageJson, pageIdsArray, magicObject) {
        const MIGRATION_MAP = {
            'wysiwyg.viewer.components.Grid': migrateGrid
        }
        const {uniqueIdGenerator} = magicObject.dataFixerUtils
        const migrationHelper = new CompsMigrationHelper(MIGRATION_MAP, uniqueIdGenerator)
        migrationHelper.migratePage(pageJson)
    }
}
